
<div class="pay-app-loader-content">
    <div class="pay-loader pay-app-loader-logo">
        <div class="pay-app-spinner">
            <svg class="svg" viewBox="50 50 100 100">
                <circle class="app" cx=100 cy=100 r=46 ></circle>
            </svg>
        </div>
    </div>
</div>
<div class="pay-app-loader-content msg">{{config?.title | translate}}</div>
